// Route-aware motion tempo — the front page breathes a little slower,
// every other page runs a touch faster. One knob for the whole brand.
// tempo > 1 means slower (durations are multiplied by it).
let tempo = 1;
const listeners = new Set();

export const getTempo = () => tempo;

// Silent assign — safe to call during render so children mount with it.
export const assignTempo = (t) => {
  tempo = t;
};

export const notifyTempo = () => {
  listeners.forEach((fn) => fn(tempo));
};

export const onTempoChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const routeTempo = (pathname) => (pathname === "/" ? 1.18 : 0.85);
